
export type UpdateUserProfile200SocialLinks = {
  github?: string;
  linkedin?: string;
  twitter?: string;
};
